import debug from 'debug'
import axios from 'axios'
import Config from '@/config'

let log = debug('store:root')

const isMobile = () => window.innerWidth < 576

const root = {

  strict: true,

  state: {
    site: null,
    loading: true,
    pages: {
      oops: {
        title: 'oops',
        bodyBlocks: [
          {
            type: 'hero',
            asset: require('@/assets/videos/goldengate.mp4'),
            mime: 'video/mp4',
          },
        ],
      },
      blank: {
        title: '',
        bodyBlocks: [
          {
            type: 'hero',
            asset:
              'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=',
            mime: 'image/png',
          },
        ],
      },
    },
    navigation: [],
    contact: {},
    isMobile: isMobile(),
  },

  mutations: {
    SET_SITE (state, site) {
      state.site = site

      log('mutation SET_SITE', state)
    },
    SET_LOADING (state, loading) {
      state.loading = loading
    },
    SET_PAGE (state, { endpoint, body }) {
      state.pages[endpoint] = body
    },
    SET_GLOBALS (state, body) {
      state.navigation = body.globalHeader
      state.contact = body.contact
    },
    SET_IS_MOBILE (state, isMobile) {
      state.isMobile = isMobile
    },
  },

  getters: {
  },

  actions: {
    init ({ commit }, site) {
      log('action init', site)
      commit('SET_SITE', site)
    },

    setLoading ({ commit }, loading) {
      log('action loading', loading)
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', loading)
        resolve(loading)
      })
    },

    setPage ({ commit }, { endpoint, page }) {
      log('setpage', page)
      commit('SET_PAGE', { endpoint, body: page })
    },

    getGlobals ({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${Config.get('apiBase')}/nav/globals.json`, {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          })
          .then(response => response.data)
          .then(body => {
            commit('SET_GLOBALS', body)
          })
          .catch(err => {
            // eslint-disable-next-line
            console.error(err)
          })
      })
    },

    getPage ({ commit, state }, endpoint) {
      return new Promise((resolve) => {
        if (state.pages[endpoint]) {
          resolve(state.pages[endpoint])
        } else {
          axios
            .get(`${Config.get('apiBase')}${endpoint}`)
            .then(response => response.data)
            .then(body => {
              commit('SET_PAGE', body)
              resolve(body)
            })
            .catch(err => {
              // eslint-disable-next-line
              console.error(err)
              resolve(state.pages['oops'])
            })
        }
      })
    },

    setIsMobile ({ commit }) {
      commit('SET_IS_MOBILE', isMobile())
    },
  },
}

export default root
